import { useSelector } from 'react-redux'
import { useIsAuthenticated } from 'app/ducks/auth/hooks'
import { getFeatureFlag } from './selectors'

/**
 * Returns whether a feature flag is on for the current user.
 *
 * Always `false` when nobody is logged in, or when the flag doesn't exist
 * in the store (unknown flag name, or the flags haven't loaded yet/failed
 * to load with nothing cached) — never throws, never renders anything
 * conditional on an "unknown" state.
 *
 * @param {string} flagName
 * @returns {boolean}
 */
const useFeatureFlag = (flagName) => {
  const isAuthenticated = useIsAuthenticated()
  const value = useSelector((state) => getFeatureFlag(state, flagName))
  return isAuthenticated ? value : false
}

export default useFeatureFlag
